module.exports = __webpack_public_path__ + "img/de_2.b67090e7.jpg";